import { useCallback, useEffect, useState } from "react";
import { RefreshCw, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { errMsg } from "../ui";
import { SyncStatusCard } from "./SyncStatusCard";
import { SyncRecipientsCard } from "./SyncRecipientsCard";
import { SyncRunsTable } from "./SyncRunsTable";

/** Billing Sync → Tracked Items Sync: the preview + apply, automatically every day. */
export function TrackedItemsSync() {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get("/billing-sync/autosync").then(({ data }) => setD(data))
    .catch((e) => toast.error(errMsg(e, "Could not load the Tracked Items Sync"))), []);
  useEffect(() => { load(); }, [load]);
  const busy = d && (d.running || d.runs.some((r) => r.status === "running"));
  useEffect(() => {
    if (!busy) return undefined;
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, [busy, load]);
  if (!d) return <Card className="p-6 text-sm text-slate-500" data-testid="tis-loading">Loading…</Card>;
  return (
    <div className="space-y-5" data-testid="tis-page">
      <Card className="flex items-start gap-3 border-emerald-200 bg-emerald-50/60 p-4 text-sm text-emerald-900">
        <RefreshCw className="mt-0.5 h-4 w-4 shrink-0" />
        <div>
          <b>Every day it runs a full Tracked Items Preview of all platforms and applies what it finds to Stax Bill</b> — adds, moves,
          removals and new subscriptions, the same as ticking every row and pressing Apply.
          <span className="mt-1 flex items-center gap-1 text-xs text-emerald-800"><ShieldCheck className="h-3.5 w-3.5" />
            Each row is re-checked live in Stax Bill before it changes; special-billing domains are skipped; every change lands in Apply History and can be undone there. The preview page stays the manual option.</span>
        </div>
      </Card>
      <div className="grid gap-5 lg:grid-cols-2">
        <SyncStatusCard d={d} reload={load} />
        <SyncRecipientsCard key={d.recipients.map((u) => u.user_id).sort().join()} d={d} reload={load} />
      </div>
      <SyncRunsTable runs={d.runs} />
    </div>
  );
}
